module.exports = __webpack_public_path__ + "static/img/ewm.ecb66c63.jpg";